/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateVendorCommand } from '../../models/update-vendor-command';
import { UpdateVendorCommandResult } from '../../models/update-vendor-command-result';

export interface ApiVendorsUpdateVendorPut$Plain$Params {
  
    /**
     * The command containing the updated details for the Vendor.
     */
    body?: UpdateVendorCommand
}

export function apiVendorsUpdateVendorPut$Plain(http: HttpClient, rootUrl: string, params?: ApiVendorsUpdateVendorPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateVendorCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiVendorsUpdateVendorPut$Plain.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateVendorCommandResult>;
    })
  );
}

apiVendorsUpdateVendorPut$Plain.PATH = '/api/Vendors/UpdateVendor';
